<template>
  <div>
    <a-card :bordered="false">
      <div slot="title">
        <a-space align="center">
          <div class="title_icon"></div>
          <div
            class="ant-descriptions-title"
            style="font-size: 16px; margin-bottom: 0px"
          >
            进场公开招租
          </div>
        </a-space>
      </div>

      <div class="search-area">
        <a-form layout="inline">
          <a-form-item label="状态">
            <a-select
              placeholder="全部"
              v-model="queryParam.projectStatus"
              style="width: 160px"
              @change="onSearch"
            >
              <a-select-option
                v-for="status in dictionaries.projectStatus"
                :key="status.value"
                :value="status.value"
              >
                {{ status.note }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="项目名称">
            <a-input-search
              placeholder="请输入项目名称"
              v-model="queryParam.projectName"
              @search="onSearch"
              style="width: 250px"
            />
          </a-form-item>

          <a-button type="primary" style="margin-top: 4px" @click="onSearch">
            查询
          </a-button>
          <a-button style="margin-left: 10px; margin-top: 4px" @click="reset">
            重置
          </a-button>
        </a-form>
      </div>

      <a-table
        :pagination="table.pagination"
        :loading="table.loading"
        :columns="table.columns"
        :data-source="table.data"
        rowKey="webId"
        :scroll="{ x: 1500 }"
        @change="handleTableChange"
      >
        <span slot="index" slot-scope="text, record, index">
          {{
            (table.pagination.current - 1) * table.pagination.pageSize +
            index +
            1
          }}
        </span>

        <span slot="projectName" slot-scope="projectName, record">
          <a
            v-if="isProjectNameLink(record)"
            :href="record.shexgrpUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ projectName }}
          </a>
          <span v-else>{{ projectName }}</span>
        </span>

        <span slot="rentCount" slot-scope="rentCount">
          {{ rentCount || "--" }}平方米
        </span>

        <span slot="projectStatus" slot-scope="projectStatus">
          {{ projectStatus | projectStatusText }}
        </span>

        <span slot="operation" slot-scope="text, record" class="operation-cell">
          <template v-if="Number(record.projectStatus) === 50">
            <a @click="openBidParamModal(record)">竞价参数预填写</a>
            <br />
          </template>
          <a @click="openNoticeModal(record)">公告截图</a>
          <a-divider type="vertical" />
          <a @click="openLetterModal(record)">项目函件</a>
          <br />
          <a @click="openIntentionModal(record)">意向方材料</a>
        </span>
      </a-table>
    </a-card>

    <bid-param-modal
      :visible="bidParam.visible"
      :record="bidParam.record"
      @close="closeBidParamModal"
      @saved="handleBidParamSaved"
    />
    <notice-screenshot-modal
      :visible="notice.visible"
      :record="notice.record"
      @close="closeNoticeModal"
    />
    <project-letter-modal
      :visible="letter.visible"
      :record="letter.record"
      @close="closeLetterModal"
    />
    <intention-material-modal
      :visible="intention.visible"
      :record="intention.record"
      @close="closeIntentionModal"
    />
  </div>
</template>

<script>
import { listPublicBidProject } from "@/api/project/Project.js";
import BidParamModal from "./components/BidParamModal.vue";
import IntentionMaterialModal from "./components/IntentionMaterialModal.vue";
import NoticeScreenshotModal from "./components/NoticeScreenshotModal.vue";
import ProjectLetterModal from "./components/ProjectLetterModal.vue";

const projectStatusType = {
  20: "已公告",
  30: "已撤牌",
  40: "已摘牌",
  50: "招租方式已选择",
  51: "成交待受理",
  52: "成交审核中",
  53: "成交受理退回",
  54: "成交退回整改",
  55: "成交整改中",
  56: "成交整改完成",
  57: "成交录入完成",
  60: "成交信息已确认",
  61: "租赁凭证已打印",
  63: "租赁凭证已生成",
  100: "已中止",
  200: "已终结",
};

const projectStatusOptions = [
  { note: "全部", value: "" },
  ...Object.keys(projectStatusType).map((value) => ({
    note: projectStatusType[value],
    value,
  })),
];

const columns = [
  {
    title: "序号",
    width: 80,
    align: "center",
    scopedSlots: { customRender: "index" },
  },
  {
    title: "项目名称",
    dataIndex: "projectName",
    width: 240,
    scopedSlots: { customRender: "projectName" },
  },
  {
    title: "项目编号",
    dataIndex: "webId",
    width: 210,
  },
  {
    title: "计租数量(租赁面积)",
    dataIndex: "rentCount",
    width: 210,
    scopedSlots: { customRender: "rentCount" },
  },
  {
    title: "项目状态",
    dataIndex: "projectStatus",
    width: 180,
    scopedSlots: { customRender: "projectStatus" },
  },
  {
    title: "招租公告起始日期",
    dataIndex: "projectStartTime",
    width: 190,
  },
  {
    title: "招租公告截止日期",
    dataIndex: "projectEndTime",
    width: 190,
  },
  {
    title: "操作",
    width: 180,
    fixed: "right",
    align: "center",
    scopedSlots: { customRender: "operation" },
  },
];

export default {
  components: {
    BidParamModal,
    IntentionMaterialModal,
    NoticeScreenshotModal,
    ProjectLetterModal,
  },
  data() {
    return {
      queryParam: {
        projectStatus: "",
        projectName: undefined,
      },
      dictionaries: {
        projectStatus: projectStatusOptions,
      },
      table: {
        loading: false,
        data: [],
        columns,
        pagination: {
          current: 1,
          pageNo: 1,
          pageSize: 10,
          total: 0,
          showTotal: (total) => `共 ${total} 条`,
        },
      },
      bidParam: {
        visible: false,
        record: null,
      },
      notice: {
        visible: false,
        record: null,
      },
      letter: {
        visible: false,
        record: null,
      },
      intention: {
        visible: false,
        record: null,
      },
    };
  },

  mounted() {
    this.getTableDetails();
  },

  filters: {
    projectStatusText(type) {
      return projectStatusType[type] || "-";
    },
  },

  methods: {
    onSearch() {
      this.getTableDetails({ page: 1 });
    },

    reset() {
      this.queryParam.projectStatus = "";
      this.queryParam.projectName = undefined;
      this.getTableDetails({ page: 1 });
    },

    handleTableChange(pagination) {
      this.getTableDetails({
        page: pagination.current,
        pageSize: pagination.pageSize,
      });
    },

    getTableDetails(params = {}) {
      this.table.loading = true;
      const page = params.page || this.table.pagination.current || 1;
      const pageSize = params.pageSize || this.table.pagination.pageSize || 10;
      const projectName = (this.queryParam.projectName || "").trim();
      const projectStatus = this.queryParam.projectStatus;

      listPublicBidProject({
        page,
        pageSize,
        projectName,
        projectStatus,
      })
        .then((res) => {
          const pageData = this.normalizePageData(res);
          const pagination = { ...this.table.pagination };
          pagination.total = pageData.total;
          pagination.pageSize = pageData.pageSize;
          pagination.pageNo = pageData.pageNo;
          pagination.current = pageData.pageNo;

          if (pageData.pageNo !== 1 && pageData.list.length === 0) {
            this.getTableDetails({
              page: pageData.pageNo - 1,
              pageSize: pageData.pageSize,
            });
            return;
          }

          this.table.data = pageData.list;
          this.table.pagination = pagination;
        })
        .catch((err) => {
          this.table.data = [];
          this.$notification["error"]({
            message: "查询失败",
            description:
              ((err.response || {}).data || {}).message ||
              err.message ||
              "网络异常，请稍后再试",
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },

    normalizePageData(res = {}) {
      const data = res.data || {};
      const list = Array.isArray(data.list)
        ? data.list
        : Array.isArray(res.data)
        ? res.data
        : [];

      return {
        list,
        total: Number(data.total || res.total || list.length || 0),
        pageNo: Number(data.pageNo || res.pageNo || res.current || 1),
        pageSize: Number(data.pageSize || res.pageSize || 10),
      };
    },

    isProjectNameLink(record = {}) {
      return (
        Number(record.projectStatus) === 20 &&
        !!record.shexgrpUrl &&
        record.shexgrpUrl !== "--"
      );
    },

    openBidParamModal(record) {
      this.bidParam.record = record;
      this.bidParam.visible = true;
    },

    closeBidParamModal() {
      this.bidParam.visible = false;
      this.bidParam.record = null;
    },

    handleBidParamSaved() {
      this.closeBidParamModal();
      this.getTableDetails();
    },

    openNoticeModal(record) {
      this.notice.record = record;
      this.notice.visible = true;
    },

    closeNoticeModal() {
      this.notice.visible = false;
      this.notice.record = null;
    },

    openLetterModal(record) {
      this.letter.record = record;
      this.letter.visible = true;
    },

    closeLetterModal() {
      this.letter.visible = false;
      this.letter.record = null;
    },

    openIntentionModal(record) {
      this.intention.record = record;
      this.intention.visible = true;
    },

    closeIntentionModal() {
      this.intention.visible = false;
      this.intention.record = null;
    },
  },
};
</script>

<style scoped>
.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

.search-area /deep/ .ant-input {
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}

.operation-cell a {
  color: #1890ff;
  line-height: 24px;
}
</style>
